<template>
  <div v-loading="loading">
    <Form>
      <Row>
        <Col span="12">
          <FormItem :label="l('SHENQINGREN')">{{item.userName}}</FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="l('SHENGQINGSHIJIAN')">{{item.applyTime}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <FormItem :label="l('SHENQINGLEIXING')">
            {{item.applyBizType == "SELF_LEVELING"
            ? l("JIANGSHITIAOJI")
            : l("JIANGSHISHENQING")}}
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('JIANGSHILEIBIE')">{{item.categoryName}}</FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="l('JIANGSHIJIBIE')">{{item.levelName}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem :label="l('SHENQINGYUANYING')">{{item.applyDescription}}</FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
export default {
  name: "userTeacherAudit",
  props: ["id"],
  data() {
    return {
      loading: false,
      item: {}
    };
  },
  methods: {
    _fetch(id) {
      if (id) {
        this.loading = true;
        this.http
          .request("user/trainTeacherApply/info", { id: id })
          .then(result => {
            this.item = result.item;
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  created: function() {
    this._fetch(this.id);
  }
};
</script>



// WEBPACK FOOTER //
// userTeacherAudit.vue?28ba85dd